"use strict";
// Schedule service for handling schedule-related API calls
// Follows clean code principles: dedicated service for schedule operations
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleServiceFactory = void 0;
// Constants for API endpoints - extract magic strings
var API_BASE = '/api/api.php';
var TASK_ACTION_ENDPOINT = "".concat(API_BASE, "?action=taskAction");
var ADD_SCHEDULE_ENDPOINT = "".concat(API_BASE, "?action=addSchedule");
// Helper function to handle HTTP errors consistently
function handleHttpError(operation) {
    return function (error) {
        console.error("ScheduleService.".concat(operation, " error:"), error);
        throw error;
    };
}
// Generic HTTP POST helper to eliminate repetition
function createTypedPost($http, url, operation) {
    return function (data) {
        return $http.post(url, data)
            .then(function (response) { return response.data; })
            .catch(handleHttpError(operation));
    };
}
// Factory function for AngularJS - now focused and clean
exports.scheduleServiceFactory = ['$http', function ($http) {
        return {
            startTask: createTypedPost($http, TASK_ACTION_ENDPOINT, 'startTask'),
            topTask: createTypedPost($http, TASK_ACTION_ENDPOINT, 'topTask'),
            laterTask: createTypedPost($http, TASK_ACTION_ENDPOINT, 'laterTask'),
            doneTask: createTypedPost($http, TASK_ACTION_ENDPOINT, 'doneTask'),
            addSchedule: createTypedPost($http, ADD_SCHEDULE_ENDPOINT, 'addSchedule'),
        };
    }];
